import { APIEndpoints } from "@/data/constants/endpoints";
import { Request } from "@/data/api/utils/network";
import { RequestParams } from "@/data/types";
import { TDashboardItem, TDashboardPayload } from "@/data/types";

/**
 * Get all dashboards with pagination options
 * @param params Request parameters including organization_id, pageNumber, pageSize, etc.
 */
export const getAllDashboards = (params: RequestParams) => {
  return Request({
    path: APIEndpoints.DASHBOARDS.BASE,
    type: "GET",
    params,
  });
};

/**
 * Create a new dashboard
 * @param params Request parameters
 * @param payload Create payload
 */
export const createDashboard = (
  params: RequestParams,
  payload: TDashboardPayload
) => {
  return Request({
    path: APIEndpoints.DASHBOARDS.BASE,
    type: "POST",
    params,
    body: payload,
  });
};

/**
 * Get a dashboard by ID
 * @param dashboardId The ID of the dashboard to retrieve
 * @param params Request parameters
 */
export const getDashboardById = (dashboardId: string, params: RequestParams) => {
  return Request({
    path: APIEndpoints.DASHBOARDS.BY_ID(dashboardId),
    type: "GET",
    params,
  });
};

/**
 * Update a dashboard by ID
 * @param dashboardId The ID of the dashboard to update
 * @param params Request parameters
 * @param payload Update payload
 */
export const updateDashboard = (
  dashboardId: string,
  params: RequestParams,
  payload: Partial<TDashboardPayload>
) => {
  return Request({
    path: APIEndpoints.DASHBOARDS.BY_ID(dashboardId),
    type: "PATCH",
    params,
    body: payload,
  });
};

/**
 * Delete a dashboard by ID
 * @param dashboardId The ID of the dashboard to delete
 * @param params Request parameters
 */
export const deleteDashboard = (dashboardId: string, params: RequestParams) => {
  return Request({
    path: APIEndpoints.DASHBOARDS.BY_ID(dashboardId),
    type: "DELETE",
    params,
  });
};